<template>
    <div>
        <card shadow>
            <div slot="header" class="bg-white border-0">
                <div class="row">
                    <div class="col-lg-6">
                        <h5 class="text-muted">หมายเลขติดตามพัสดุ: <span class="h4">{{orderDetails.barcode}}</span></h5>
                    </div>
                    <div class="col-lg-6 text-right">
                        <h5 class="text-muted">วันที่สร้างรายการ: <span class="h4">{{orderDetails.created_at | dateFormat}}</span></h5>
                    </div>
                </div>
                <div class="row px-2">
                    <div class="col-lg-5">
                        <h5 class="text-muted">จาก: <span class="h4">{{orderDetails.from.name}}</span></h5>
                        <h5 class="text-muted">เบอร์โทรศัพท์: <span class="h4">{{orderDetails.from.tel}}</span></h5>
                        <h5 class="text-muted">ที่อยู่: <span class="h4">{{[orderDetails.from.address,orderDetails.from.state,orderDetails.from.district,orderDetails.from.province,orderDetails.from.postcode].join(" ")}}</span></h5>
                    </div>
                    <div class="col-lg-2 d-flex align-items-center">
                        <i class="fas fa-angle-double-right text-primary fa-lg"></i>
                    </div>
                    <div class="col-lg-5">
                        <h5 class="text-muted">ถึง: <span class="h4">{{orderDetails.to.name}}</span></h5>
                        <h5 class="text-muted">เบอร์โทรศัพท์: <span class="h4">{{orderDetails.to.tel}}</span></h5>
                        <h5 class="text-muted">ที่อยู่: <span class="h4">{{[orderDetails.to.address,orderDetails.to.district,orderDetails.to.state,orderDetails.to.province,orderDetails.to.postcode].join(" ")}}</span></h5>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <h4>รายละเอียดพัสดุ</h4>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-4">
                    <h5 class="text-muted">น้ำหนัก {{ $THEME.unitKG ? '(kg.)' : '(g.)'}}: <span class="h4">{{ ( orderDetails.weight ) ? ( ( $THEME.unitKG ) ? (orderDetails.weight / 1000) : orderDetails.weight ) : '-' }}</span></h5>
                    <h5 v-if="$USER_LOGIN.get().isShippop" class="text-muted">น้ำหนักจริง {{ $THEME.unitKG ? '(kg.)' : '(g.)'}}: <span class="h4">{{ ( orderDetails.rweight ) ? ( ( $THEME.unitKG ) ? (orderDetails.rweight / 1000) : orderDetails.rweight ) : '-' }}</span></h5>
                    <h5 class="text-muted">ยอด COD: <span class="h4">{{orderDetails.cod_amount}}</span></h5>
                    <h5 class="text-muted">ประกันคุ้มครองพัสดุ: <span class="h4">{{orderDetails.declared_value}}</span></h5>
                </div>
                <div class="col-lg-4">
                    <h5 class="text-muted">ขนาดพัสดุ (cm): 
                        <span class="h4">
                            <template v-if="orderDetails.width + orderDetails.length + orderDetails.height <= 3">
                                -
                            </template>
                            <template v-else>
                                {{orderDetails.width+'x'+orderDetails.length+'x'+orderDetails.height}}
                            </template>
                        </span>
                    </h5>
                    <h5 v-if="$USER_LOGIN.get().isShippop" class="text-muted">ขนาดพัสดุ จริง (cm): 
                        <span class="h4">
                            <template v-if="orderDetails.rwidth + orderDetails.rlength + orderDetails.rheight <= 3">
                                -
                            </template>
                            <template v-else>
                                {{orderDetails.rwidth+'x'+orderDetails.rlength+'x'+orderDetails.rheight}}
                            </template>
                        </span>
                    </h5>
                    <h5 class="text-muted">ค่าธรรมเนียม COD: <span class="h4">{{orderDetails.cod_fee}}</span></h5>
                    <h5 class="text-muted">ค่าบริการประกันพัสดุ: <span class="h4">{{orderDetails.insurance_price}}</span></h5>
                </div>
                <div class="col-lg-4">
                    <h5 class="text-muted">รายละเอียดสินค้า: <span class="h4">{{(orderDetails.insurance_remark ? orderDetails.insurance_remark : '-')}}</span></h5>
                    <h5 class="text-muted">รหัสสาขา: <span class="h4">{{orderDetails.shop_code}}</span></h5>
                    <h5 class="text-muted">สถานะพัสดุ: 
                        <b-badge :variant="statusInfo(orderDetails).color" >
                            {{statusInfo(orderDetails).status}}
                        </b-badge>
                    </h5>
                    <h5 class="text-muted">ค่าส่งพัสดุ: <span class="h4">{{orderDetails.price}}</span></h5>
                </div>
            </div>
        </card>
        <card v-if="isCOD()" shadow type="secondary">
            <div class="row mt-3">
                <div class="col-lg-4">
                    <h4>ข้อมูลเก็บเงินปลายทาง</h4>
                </div>
                <div class="col-lg-4"></div>
                <div v-if="orderDetails.account_cod.length > 0 && orderDetails.cod_amount > 0" class="col-lg-4">
                    <h4>ข้อมูลการโอนคืน</h4>
                </div>
                <div v-else class="col-lg-4"></div>
            </div>
            <div class="row">
                <div class="col-lg-4">
                    <h5 class="text-muted">ยอดเก็บเงินปลายทาง: <span class="h4">{{orderDetails.cod_amount}}</span></h5>
                    <h5 class="text-muted">ค่าธรรมเนียม : <span class="h4">{{orderDetails.cod_fee}}</span></h5>
                    <h5 class="text-muted">ยอดโอนคืน : <span class="h4">{{orderDetails.cod_charge}}</span></h5>
                    <h5 class="text-muted">วันที่โอนเงินคืนลูกค้า : 
                        <span class="h4" v-if="orderDetails.date_time_transfer != null">{{ orderDetails.date_time_transfer | dateFormat }}</span>
                        <span class="h4" v-else>-</span>
                    </h5>
                    <h5 class="text-muted">สถานะ : 
                        <b-badge :variant="statusInfo(orderDetails).color" >
                            {{statusInfo(orderDetails).status}}
                        </b-badge>    
                    </h5>

                </div>
                <div class="col-lg-4">
                </div>
                <div v-if="orderDetails.account_cod.length > 0 && orderDetails.cod_amount > 0" class="col-lg-4">
                    <h5 class="text-muted">ธนาคาร: <span class="h4">{{findBankName(orderDetails.account_cod[0].account_bank)}}</span></h5>
                    <h5 class="text-muted">เลขบัญชี: <span class="h4">{{orderDetails.account_cod[0].account_id}}</span></h5>
                    <h5 class="text-muted">ชื่อบัญชี: <span class="h4">{{orderDetails.account_cod[0].account_name}}</span></h5>
                </div>
                <div v-else class="col-lg-4">
                </div>
            </div>
        </card>
        <card v-if="isInsurance()" shadow type="secondary">
            <div class="row mt-3">
                <div class="col-lg-4">
                    <h4>ประกันภัยพัสดุ</h4>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-4">
                    <h5 class="text-muted">ประเภทของสินค้า : <span class="h4">{{orderDetails.insuranceAll.remark}}</span></h5>
                    <h5 v-if="$USER_LOGIN.get().isShippop" class="text-muted">ยอดที่เรียกเก็บ : <span class="h4">{{orderDetails.insuranceAll.cost}}</span></h5>
                    <h5 class="text-muted">มูลค่าที่เอาประกัน : <span class="h4">{{orderDetails.insuranceAll.declared_value}}</span></h5>
                    <h5 class="text-muted">เวลายกเลิก :
                        <span class="h4" v-if="orderDetails.insuranceAll.deleted_at != null">{{ orderDetails.insuranceAll.deleted_at | dateFormat }}</span>
                        <span class="h4" v-else>-</span> 
                    </h5>
                </div>
                <div class="col-lg-4">
                </div>
                <div class="col-lg-4">
                </div>
            </div>
        </card>
    </div>
</template>

<script>
import { statusInfo } from "@/plugins/statusCourier.js"
import formatBank  from "@/plugins/formatBank.js"
import moment from "moment";

export default {
    name:"orderDetails",
    props:{
        orderDetails: Object
    },
    filters: {
        dateFormat(date) {
            return moment(date, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY HH:mm");
        },
    },
    data(){
        return{
            statusInfo: statusInfo,
        }
    },
    methods: {
        findBankName (code) {
            const bankName = formatBank.find(val => val.code === code)
            return bankName.name
        },
        isCOD() {
            return this.$USER_LOGIN.get().isShippop && this.orderDetails.cod_amount > 0
        },
        isInsurance() {
            return this.orderDetails.insuranceAll != null
        }
    },
}
</script>